import React from "react";

import PageWrapper from "../../../../components/layout/page/PageWrapper";
import PageHeader from "../../../../components/layout/page/PageHeader";
import Text from "../../../../components/typography/Text";
import EmptyState from "../../../../components/feedback/EmptyState";
import ContentGrid from "../../../../components/grids/content/ContentGrid";
import Button from "../../../../components/buttons/Button";

import { useSharedTalents } from "../hooks/useSharedTalents";
import SharedTalentCard from "../../components/cards/SharedTalentCard";

import "./SharedTalentsPage.css";

export default function SharedTalentsPage() {
  const { talents, loading, loadingMore, error, hasMore, loadMore, refresh } =
    useSharedTalents();

  return (
    <PageWrapper>
      <div className="shared-talents">
        <PageHeader
          title="Talents"
          description="Discover athletes and their sporting profiles."
        />

        {loading ? (
          <Text as="p" tone="secondary" size="sm">
            Loading talents...
          </Text>
        ) : (
          <>
            {talents.length > 0 && (
              <ContentGrid
                items={talents}
                columns={2}
                mobileColumns={1}
                renderItem={(item) => (
                  <SharedTalentCard key={item.talentId} talent={item} />
                )}
              />
            )}

            {!talents.length && !error && (
              <EmptyState
                title="No talents available"
                description="Public Talent IDs will appear here."
              />
            )}

            {error && (
              <div className="shared-talents__error" role="alert">
                <Text as="p" size="sm">
                  {error}
                </Text>

                <Button
                  value="Retry"
                  variant="primary-outlined"
                  disabled={loadingMore}
                  onClick={talents.length ? loadMore : refresh}
                />
              </div>
            )}

            {hasMore && !error && (
              <div className="shared-talents__load-more">
                <Button
                  value={loadingMore ? "Loading..." : "Load More"}
                  variant="primary-outlined"
                  disabled={loadingMore}
                  onClick={loadMore}
                />
              </div>
            )}
          </>
        )}
      </div>
    </PageWrapper>
  );
}
